// Sort images using a given array as a guide
export function guideSort (guide, key) {
  return (a, b) => {
    a = key ? a[key] : a
    b = key ? b[key] : b
    var indexA = guide.indexOf(a)
    var indexB = guide.indexOf(b)
    if (indexA !== -1 && indexB === -1) return -1
    if (indexA === -1 && indexB !== -1) return 1
    if (indexA < indexB) return -1
    if (indexA > indexB) return 1
    return 0
  }
}

// http://stackoverflow.com/a/6274381
export function shuffle (a) {
  let j, x, i
  for (i = a.length; i; i--) {
    j = Math.floor(Math.random() * i)
    x = a[i - 1]
    a[i - 1] = a[j]
    a[j] = x
  }
  return a
}



// WEBPACK FOOTER //
// ./src/utils/array.js